import { VideoButtonProps } from './Types'
import { track } from '@tldraw/tldraw'
import { ToolbarButton } from '../../components/ToolbarButton'
import { SpaceWidth } from 'blaze-ui/icons/24'
import { fitAndPositionShape } from './helpers'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const FillButton = track(({ editor, selectedShape }: VideoButtonProps) => {
  const { isMobile } = useResponsiveDesign()
  const handlePress = () => {
    fitAndPositionShape(editor, selectedShape, 'cover')
  }

  return (
    <ToolbarButton frontIcon={() => <SpaceWidth size={20} />} onPress={handlePress}>
      {!isMobile && 'Fill Canvas'}
    </ToolbarButton>
  )
})

export { FillButton }
